import React, { useContext, useMemo } from "react";
import "./DownloadCampaignsModal.scss";
// Context
import { DataTableContext } from "../ViewMasterCampaigns/Tabs/Overview";
// Component Library
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";

const DownloadCampaignsModal = ({ handleDownload, selectAllState }) => {
	const { checkboxSelections } = useContext(DataTableContext);

	const platformCounts = useMemo(() => {
		const renderedCampaignCount = [];
		const campaignCount = {};
		checkboxSelections?.selectedActivationCampaigns?.forEach((campaign) => {
			if (!campaignCount[campaign.platform]) {
				campaignCount[campaign.platform] = 1;
			} else {
				campaignCount[campaign.platform] = campaignCount[campaign.platform] + 1;
			}
		});
		Object.keys(campaignCount).forEach((platform) => {
			renderedCampaignCount.push(
				<div key={`${platform}Count`} className="campaignCount">
					<span className="regularText">{platform}</span>
					<span className="regularText">{selectAllState === 1 ? "..." : campaignCount[platform]}</span>
				</div>
			);
		});
		return renderedCampaignCount;
	}, [checkboxSelections, selectAllState]);

	const totalValue = useMemo(() => {
		const totalCount = checkboxSelections?.dataTableApi?.current?.dataProvider?.totalActivationCampaignsCount;
		const selectedCount = checkboxSelections?.selectedActivationCampaigns?.length;
		return selectAllState === 1 ? totalCount : selectedCount;
	}, [checkboxSelections, selectAllState]);

	return (
		<Modal
			id="downloadCampaignModal"
			heading="Download"
			description='The selected campaigns are listed below. Click the "Download" button to initiate a download request for the selected campaigns.'
			actionSetProps={{
				actionsRight: (
					<>
						<Button
							display={BUTTON_DISPLAY.SECONDARY}
							onClick={() => {
								Modal.hide("downloadCampaignModal");
							}}
							data-tracking-id-alt="cancel-download-campaigns"
						>
							Cancel
						</Button>
						<Button
							onClick={() => {
								Modal.hide("downloadCampaignModal");
								handleDownload();
							}}
							data-tracking-id-alt="confirm-download-campaigns"
						>
							Download
						</Button>
					</>
				)
			}}
			onClick={() => {}}
		>
			<div className="campaignListContainer">
				<div className="campaignListHeader">
					<span className="boldText">Activation Campaign</span>
					<span className="boldText">Counts</span>
				</div>
				{platformCounts}
				<div className="totalCount">
					<span className="boldText">Total</span>
					<span className="regularText">{totalValue}</span>
				</div>
			</div>
		</Modal>
	);
};
export default DownloadCampaignsModal;
